import { type OpenApiGetImportVariantsInProductListStatusResponseSuccess } from '#shared/api/schema';

const EMPTY_IMPORT_START_DATE_PREFIX = '0001-01-01';

export const isEmptyProductListImportStatus = (
    importStatus: OpenApiGetImportVariantsInProductListStatusResponseSuccess
) =>
    importStatus.status === 'in_progress' &&
    !importStatus.source_file_name &&
    importStatus.start_date?.startsWith(EMPTY_IMPORT_START_DATE_PREFIX);
